//记得在 src\components\lang\zhLoad.js 里面添加对象
const bestPractices = {
  taskId:'任务包ID',
  taskName: '任务名称',
  taskType: '任务类型',
  applicableArea: '适用区域',
  taskCycle: '任务周期',
  claimed: '已领取',
  status: '状态',
  homefeed:'首页推送',
  homeRankings: '首页排行',
  taskPkgMustFlag: '是否必做',
  caseBeginDate: '开始时间',
  caseEndDate: '结束时间',
  caseDesc: '案例详情',
  alwaysFlag: '长期',
  caseImage: '案例图片',
  activeOff: '是否有效',
  msg: {}
};
export default bestPractices



// WEBPACK FOOTER //
// ./src/page/case/bestPractices/lang/bestPractices.en.js